export const getDialogConfig = (type) => {
  const configs = {
    menu: {
      title: "Menu",
      fields: [
        {
          name: "nome",
          label: "Nome do Menu",
          type: "text",
          required: true,
          placeholder: "Ex: Bebidas, Comidas",
        },
        {
          name: "icone",
          label: "Icone",
          type: "file",
          required: false,
          placeholder: "Icone",
        },
      ],
    },
    group: {
      title: "Agrupamento",
      fields: [
        {
          name: "nome",
          label: "Nome do Agrupamento",
          type: "text",
          required: true,
          placeholder: "Ex: Cervejas, Petiscos",
        },
      ],
    },
  }

  return configs[type];
};